import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../assets/images/i-money1.jpg'
import _imports_1 from '../../../assets/images/arrowtopleft.svg'
import _imports_2 from '../../../assets/images/arrowtopright.svg'
import _imports_3 from '../../../assets/images/check.svg'
import _imports_4 from '../../../assets/images/imoji.svg'
import _imports_5 from '../../../assets/images/arrowbottomleft.svg'
import _imports_6 from '../../../assets/images/arrowbottomright.svg'


const _hoisted_1 = {
  class: "row mx-auto mt-1",
  style: {}
}
const _hoisted_2 = { class: "col-12 col-md-8 col-lg-6 col-xl-7 col-xxl-6 col-xxxl-4" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" }
const _hoisted_4 = { class: "card-body letter-spacing row" }
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = {
  key: 0,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_9 = {
  key: 1,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_10 = {
  key: 2,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_11 = {
  key: 3,
  class: "row line-numbers bg-gray pt-0 pb-0 ps-25 pe-25 mb-0"
}
const _hoisted_12 = {
  key: 4,
  class: "form-group mb-15 mb-sm-20 mb-md-25"
}
const _hoisted_13 = { id: "body_receipt" }
const _hoisted_14 = { id: "body_first_section" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "section_content" }
const _hoisted_17 = { class: "section_content" }
const _hoisted_18 = { class: "section_content" }
const _hoisted_19 = { class: "section_content" }
const _hoisted_20 = { style: {"margin-top":"10%"} }
const _hoisted_21 = { class: "section_content_other" }
const _hoisted_22 = { id: "body_second_section" }
const _hoisted_23 = { class: "section_content_other1" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }

import router from '@/router';
import { useRoute } from 'vue-router'
import axios from 'axios';
import { ref, reactive, inject, onMounted } from 'vue';
import html2pdf from "html2pdf.js";
import 'vue-tel-input/vue-tel-input.css';

import { Country, Fee, Operator } from "@/utils/Model";

import { validate_phone_number, formatDateFr } from "../../../utils/function";

export default /*@__PURE__*/_defineComponent({
  __name: 'TransactionSuccessContent',
  setup(__props) {

const backApi = inject('back');
const error = ref('');
const errors = ref('');
const errorId = ref('');
const success = ref('');
const name = ref('');
//const errorsBis = { 'otp': "", 'amount': 0 };//'name':'',
const phone = ref("");
const operators = ref(new Array<Operator>());
let operatorsTemp = new Array<Operator>();

let token: string | null = localStorage.getItem('login_token');
let environment = process.env.VUE_APP_TEST
const selectedOperator = ref('');
if (process.env.VUE_APP_TEST == 'DEMO') {
  selectedOperator.value = 'WAVE';
}

// let contrycode = '';
// let contryIndicatif = ''
const step0 = ref(0);
const step1 = ref(1);
const step2 = ref(0);
const step3 = ref(0);
let checkoutId = "";
let publicToken: string | null = '';
const amount = ref(0);
const status = ref(null);
// let countRetry = 0;
// let linkGenerated = false;
// let verify_transact;
// let sampleInterval;
// const btnLoad = ref(true);
// const pageLoad = ref(false);
// let startingMinutes = ref(5);
// let startingSeconds = ref(0);
// const mins = ref(startingMinutes);
// const secs = ref(startingSeconds);


const goback = () => {
  step1.value = 1;
  step2.value = 0;
  step3.value = 0;
  router.go(0)
}



const showPublicTransaction = (token) => {

  axios.get(backApi + '/public/transactions/' + token, {  //secure
    headers: {
      'Content-Type': 'application/json',
    }
  })
    .then((response) => {
      if (response.status == 200) {
        amount.value = response.data.amount;  //.data.users   
        status.value = response.data.paymentStatus;
         //console.log("response.data", response.data);
         if(response.data.operationType == "1"){
          checkoutId = response.data.checkoutId;
         }else{
          checkoutId = response.data.payoutId;
         }
        selectedOperator.value = response.data.operator?.mnoName || '';
        phone.value = response.data.contact

      }

    }).catch((error) => {
      if (error.response) {
        // console.log(error.response.data); // => the response payload 
        if (error.response) {
          // errorId.value=error.response.data.errorId;            
          // errors.value=error.response.data.message;  
          // errorId.value=error.response.data.errorId;            
          errors.value = error.response.data;
          router.push('/');
        }

      }
    });
  //  loader.value=true;
}


const PDFReceipt = ref<HTMLElement | null>(null);

const download_receipt = () => {
  //searchTransactionExportToPDF()
  // jQuery.event.trigger({ type: 'keydown', which: 77 });
  var event; // The custom event that will be created
  // if(document.createEvent){
  //     event = document.createEvent("HTMLEvents");
  //     event.initEvent("dataavailable", true, true);
  //     event.eventName = "dataavailable";
  //     element.dispatchEvent(event);
  // } 
  //else {
  //     event = document.createEventObject();
  //     event.eventName = "dataavailable";
  //     event.eventType = "dataavailable";
  //     element.fireEvent("on" + event.eventType, event);
  // }
  
  const element = PDFReceipt.value;
  element.classList.remove("d-none");

  setTimeout(() => {

    document.getElementById("receipt").style.display = 'block';
    
    // document.getElementById("receipt").style.border = 'none';

    // // document.getElementById("receipt").style.visibility='hidden';
    const opt = {
      margin: [0, 0, 0, 0], filename: "receipt_" + publicToken + ".pdf", jsPDF: { unit: 'mm', format: 'a5', orientation: 'portrait', putOnlyUsedFonts: true, floatPrecision: "smart" }, image: { type: 'jpeg', quality: 0.98 },

      html2canvas: { scale: 2 },
    }
    html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().save()
    // html2pdf().set(opt).from(document.getElementById("receipt")).toPdf().get('pdf').then(function (pdf) {      
    //   window.open(pdf.output('bloburl'), '_blank');
    //   document.getElementById("receipt").style.display='none';
    // });

  }, 3000);
  document.getElementById("receipt").style.border = ' 1px solid #706F6F';
}

onMounted(() => {
  const route = useRoute();
  publicToken = route.params.token as string;
  
  showPublicTransaction(publicToken)

});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (step0.value == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (step0.value == 0 && status.value == 'SUCCEEDED')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("h2", { class: "text-center" }, [
                            _createElementVNode("i", {
                              class: "flaticon-secure-shield",
                              style: {"color":"green"}
                            })
                          ], -1),
                          _createElementVNode("h3", { class: "text-center" }, "Votre paiement a été approuvé", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (step0.value == 0 && status.value == 'FAILED')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("h2", { class: "text-center" }, [
                            _createElementVNode("i", {
                              class: "flaticon-cancel",
                              style: {"color":"red"}
                            })
                          ], -1),
                          _createElementVNode("h2", { class: "text-center" }, "Votre paiement a échoué", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (step0.value == 0 && (status.value == 'PROCESSING' || status.value == 'PENDING'))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("h2", { class: "text-center" }, [
                            _createElementVNode("i", {
                              class: "flaticon-compare",
                              style: {"color":"blue"}
                            })
                          ], -1),
                          _createElementVNode("h2", { class: "text-center" }, "Votre paiement est en cours", -1)
                        ]))]))
                      : _createCommentVNode("", true),
                    (step0.value == 0 && status.value != 'SUCCEEDED')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createElementVNode("p", null, [
                            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-black fw-bold" }, "Opérateur : ", -1)),
                            _createElementVNode("span", null, _toDisplayString(selectedOperator.value), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-black fw-bold" }, "ID Transaction : ", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(checkoutId)), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-black fw-bold" }, "Date Paiement : ", -1)),
                            _createElementVNode("span", null, _toDisplayString(_unref(formatDateFr)(new Date())), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (step0.value == 0 && status.value == 'SUCCEEDED')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _createElementVNode("button", {
                            onClick: download_receipt,
                            class: "default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 d-block w-100 border border-warning",
                            style: {"background-color":"#fff","border-color":"#EB9355","border-width":"1px","border-style":"solid"}
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("span", {
                              class: "align-baseline",
                              style: {"color":"#EB9355"}
                            }, "Télécharger le réçu", -1)
                          ]))])
                        ]))
                      : _createCommentVNode("", true),
                    (step0.value == 0 && status.value == 'SUCCEEDED')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 5,
                          ref_key: "PDFReceipt",
                          ref: PDFReceipt,
                          id: "receipt",
                          class: "form-group mb-15 mb-sm-20 mb-md-25 PDFReceipt d-none"
                        }, [
                          _cache[22] || (_cache[22] = _createStaticVNode("<div id=\"header_receipt\" data-v-4b24e9f8><h2 style=\"padding:2% 5% 2% 5%;color:#fff;\" data-v-4b24e9f8><span data-v-4b24e9f8><img src=\"" + _imports_0 + "\" alt=\"logo-icon\" style=\"max-width:10%;\" data-v-4b24e9f8><span class=\"logo_text\" data-v-4b24e9f8>IZYPAY</span></span><span id=\"header_text\" data-v-4b24e9f8> REÇU DE TRANSACTION </span></h2></div>", 1)),
                          _createElementVNode("div", _hoisted_13, [
                            _cache[20] || (_cache[20] = _createStaticVNode("<div id=\"arrow-top-section\" data-v-4b24e9f8><span id=\"arrow-top-left\" class=\"section_content\" data-v-4b24e9f8><img src=\"" + _imports_1 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-4b24e9f8></span><span id=\"arrow-top-right\" class=\"section_content\" data-v-4b24e9f8><img src=\"" + _imports_2 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-4b24e9f8></span></div>", 1)),
                            _createElementVNode("div", _hoisted_14, [
                              (name.value != '')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "section_label" }, "BENEFICIAIRE", -1)),
                                    _cache[8] || (_cache[8] = _createTextVNode(" : ", -1)),
                                    _createElementVNode("span", _hoisted_16, _toDisplayString(name.value), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", null, [
                                _cache[9] || (_cache[9] = _createElementVNode("span", { class: "section_label" }, "OPERATEUR", -1)),
                                _cache[10] || (_cache[10] = _createTextVNode(" : ", -1)),
                                _createElementVNode("span", _hoisted_17, _toDisplayString(selectedOperator.value), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "section_label" }, "TELEPHONE", -1)),
                                _cache[12] || (_cache[12] = _createTextVNode(" : ", -1)),
                                _createElementVNode("span", _hoisted_18, _toDisplayString(phone.value), 1)
                              ]),
                              _createElementVNode("p", null, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "section_label" }, "DATE", -1)),
                                _cache[14] || (_cache[14] = _createTextVNode(" : ", -1)),
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(formatDateFr)(new Date())), 1)
                              ]),
                              _createElementVNode("p", _hoisted_20, [
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "section_label" }, "CODE DE TRANSACTION", -1)),
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_unref(checkoutId)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("p", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "section_label" }, "MONTANT...................................... ", -1)),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(amount.value) + " F", 1)
                              ]),
                              (status.value === 'FAILED')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_24, [...(_cache[17] || (_cache[17] = [
                                    _createElementVNode("span", { class: "section_label" }, "STATUT........................................... ", -1),
                                    _createElementVNode("span", { class: "section_content_other1" }, [
                                      _createTextVNode("ECHEC "),
                                      _createElementVNode("img", {
                                        src: _imports_3,
                                        alt: "logo-icon",
                                        style: {"max-width":"25%"}
                                      })
                                    ], -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (status.value === 'SUCCEEDED')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_25, [...(_cache[18] || (_cache[18] = [
                                    _createElementVNode("span", { class: "section_label" }, "STATUT........................................... ", -1),
                                    _createElementVNode("span", { class: "section_content_other1" }, [
                                      _createTextVNode("SUCCÈS "),
                                      _createElementVNode("img", {
                                        src: _imports_3,
                                        alt: "logo-icon",
                                        style: {"max-width":"25%"}
                                      })
                                    ], -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (status.value === 'PROCESSING')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_26, [...(_cache[19] || (_cache[19] = [
                                    _createElementVNode("span", { class: "section_label" }, "STATUT........................................... ", -1),
                                    _createElementVNode("span", { class: "section_content_other1" }, [
                                      _createTextVNode("EN COURS "),
                                      _createElementVNode("img", {
                                        src: _imports_3,
                                        alt: "logo-icon",
                                        style: {"max-width":"25%"}
                                      })
                                    ], -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ]),
                            _cache[21] || (_cache[21] = _createStaticVNode("<div id=\"body_third_section\" data-v-4b24e9f8><p data-v-4b24e9f8><span class=\"section_label\" data-v-4b24e9f8>MERCI POUR LA CONFIANCE !</span>  <span class=\"section_content\" data-v-4b24e9f8><img src=\"" + _imports_4 + "\" alt=\"logo-icon\" style=\"max-width:25%;\" data-v-4b24e9f8></span></p></div><div id=\"arrow-bottom-section\" data-v-4b24e9f8><span id=\"arrow-bottom-left\" class=\"section_content\" data-v-4b24e9f8><img src=\"" + _imports_5 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-4b24e9f8></span><span id=\"arrow-bottom-right\" class=\"section_content\" data-v-4b24e9f8><img src=\"" + _imports_6 + "\" alt=\"logo-icon\" style=\"min-width:3%;\" data-v-4b24e9f8></span></div>", 2))
                          ])
                        ], 512))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}
}

})